module.exports = __webpack_public_path__ + "officialStatic/img/logo21.b7dc9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo21.png
// module id = Fi6+
// module chunks = 0